<template>
	<div>
		<v-checkbox
			class="grv-input mb-2"
			:input-value="value"
			:name="param.name"
			@change="$emit('update:value', $event)"
			:readonly="readonly"
			color="primary"
			hide-details>

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-checkbox>

		<Hint :param="param"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly'
	],
	components: {
		Label,
		Hint
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/boolean.vue